import styled from 'styled-components'

const Title = styled.h1`
  margin-top: 30px;
  font-size: ${(p) => p.theme.h1FontSize};
`

export { Title }
